import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/_services/main.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  sub_FAQTitles: Subscription;
  sub_FAQAnswers: Subscription;
  sub_FAQSearch: Subscription;
  titles = [];
  categories = [];
  backup = null;
  searchTimer = null;
  expandCategories = [];

  constructor(
    private _mainService: MainService,
    // public dialogRef: MatDialogRef<FaqComponent>
    ) { }

  ngOnInit() {
    this.getTitles(()=>{
      if (this.titles.length){
        this.titles.forEach(title => {
          //populate categories
          if (this.categories.indexOf(title.category) == -1){
            this.categories.push(title.category);
            this.expandCategories.push(false);
          }
        });
      }
    });
  }

  getTitles(callback){
    this.sub_FAQTitles = this._mainService.getFAQTitles().subscribe(res => {
      this.titles = (typeof res !== 'undefined' && typeof res.titles !== 'undefined')?res.titles:[];
      callback();
    });
  }

  getItem(id,callback){ 
    this.sub_FAQAnswers = this._mainService.getFAQItem(id).subscribe(res => {
      callback((typeof res !== 'undefined' && typeof res.documents !== 'undefined' && res.documents.length)?res.documents[0].data:'');
    });
  }

  search(query,callback){
    this.sub_FAQSearch = this._mainService.searchFAQ(query).subscribe(res => {
      callback((typeof res !== 'undefined' && typeof res.documents !== 'undefined' && res.documents.length)?res.documents:[]);
    });
  }

  loadAnswer(index,category){
    const filtered = this.titles.filter(title => title.category === category);
    const fid = filtered[index].fid;
    this.getItem(fid,(answer) => {
      this.titles.forEach((title,i) => {
        if (title.fid == fid) this.titles[i].data = answer;
      });
    });
  }

  titleTracker(index,item){
    return item.fid;
  }

  searchChange(value){
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(()=>{
      if (value.length >= 3){
        if (this.backup == null) this.backup = JSON.parse(JSON.stringify(this.titles));
        this.search(value,(results)=>{
          if (results.length){
            const fids = results.map(entry => entry.fid);
            this.titles = this.titles.filter(title => fids.indexOf(title.fid) > -1);
          } else {
            this.titles = [];
          }
          this.expandCategories.forEach((c,index) => {
            this.expandCategories[index] = true;
          });
        });
      } else if (!value.length){
        this.expandCategories.forEach((c,index) => {
          this.expandCategories[index] = false;
        });
        if (this.backup.length){
          this.titles = JSON.parse(JSON.stringify(this.backup));
          this.backup = null;
        }
      }
    },800);
  }

  messageSupport(){
    window.location.href = `${environment.phpUrl}` + '/user/messages/MjUz';
  }

}